export default __webpack_public_path__ + "static/media/34_Kukacka_obecna_800px-Kuckuck_-Cuculus_canorus-_by_Tim_Peukert_wikipedie_thumb-min.52d2f9bc.jpg";